import React, { memo } from 'react'
import './Toolbar.scss'
import { ChildrenProp } from '../../jsx'

interface Props extends ChildrenProp {}

export const Toolbar = memo(function Toolbar ({ children }: Props) {
  return <div className="toolbar">{children}</div>
})
